module.exports = __webpack_public_path__ + "static/media/upload-proofs.e52fc691.svg";